import { Component, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Configuration } from '../../models/configuration';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-configuration-download-form',
  templateUrl: 'configuration-download-form.component.html',
  imports: [TranslatePipe],
})
export class ConfigurationDownloadFormComponent {
  private readonly ref = inject(DynamicDialogRef);
  private readonly config = inject(
    DynamicDialogConfig<{ configuration: Configuration }>,
  );
  configuration = this.config.data?.configuration;

  confirmDownload() {
    if (this.configuration?.downloadLink) {
      window.open(this.configuration.downloadLink, '_blank');
    }
    this.ref.close();
  }

  close() {
    this.ref.close();
  }
}
